import { gql } from 'graphql-request';

import {
  TeamCreatedAt,
  TeamName,
  TeamNanoID,
  TeamTeamType,
  TeamUpdatedAt,
  TeamUUID
} from '../teamsTypes';

export interface FetchCacheTeamsFilterQueryResponse {
  nanoId: TeamNanoID;
  uuid: TeamUUID;
  name: TeamName;
  createdAt: TeamCreatedAt;
  teamType?: TeamTeamType;
  updatedAt: TeamUpdatedAt;
}

export const FETCH_CACHE_TEAMS_FILTER_QUERY = gql`
  query CacheTeamsFilter(
    $filters: TeamsFilters
    $sort: [TeamsSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    teams(
      filters: $filters
      sort: $sort
      offset: $offset
      limit: $limit
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        nanoId
        uuid
        name
        teamType
        createdAt
        updatedAt
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
